<template>
  <div>
    <!-- 个人及事业单位 -->
    <van-empty image="error" description="个人及事业单位" />
    <!-- 企业 -->
    <van-empty image="network" description="企业" />
  </div>
</template>
<script>
import {
  Checkbox, CheckboxGroup, Card, SubmitBar, NavBar, Tabbar, TabbarItem,Stepper, Button, Icon, Empty
} from 'vant';

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Empty.name]: Empty
  },

  data() {
    return {

    }
  }
}
</script>
<style scoped>

</style>